// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".offerBox {\n  border-left: 1px solid #ccc !important;\n  /* border-radius: 10px !important; */\n  padding: 8px !important;\n  margin: 5px;\n  /* box-shadow: -1px 1px 5px 1px rgba(0,0,0,0.1) */\n  /* width: 150px; */\n}\n\n.noOffer h6 {\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #828282;\n    text-align: center;    \n}\n", ""]);
// Exports
module.exports = exports;
